import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { setGender } from '../../actions/userActions';

@connect((store) => {
    return { gender: store.user.gender };
})
class GenderSelect extends React.Component {

    setGender(gender) {
        this.props.dispatch(setGender(gender));
        if (gender === 'female') {
            this.props.history.push('/timesince');
        } else {
            this.props.history.push('/male');
        }
    }
    
    render() {
        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <h1 className="ec__font__title text-center">Welcome to Easy EC!</h1>
                        <p className="ec__font__body ec__font__body--blue text-center">
                            We just gotta ask a few confidential questions so we can find the best resources for you.
                        </p>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <p className="ec__font__body text-center">
                            Do you identify as a guy or a girl?
                        </p>
                    </div>
                </div>
                <div className="choices choices--small row">
                    <div className="col-md-6 text-center">
                        <button className="ec__button" onClick={this.setGender.bind(this, 'female')}>Girl</button>
                    </div>
                    <div className="col-md-6 text-center">
                        <button className="ec__button" onClick={this.setGender.bind(this, 'male')}>Guy</button>
                    </div>
                </div>
                <a href="https://www.womenshealth.gov/a-z-topics/emergency-contraception"
                    target="_blank" rel="noopener" className="ec__text-link ec__text-link--extra-margin">
                    What is EC?
                </a>
            </div>
        )
    }
}

export default GenderSelect;


// WEBPACK FOOTER //
// ./src/components/screens/GenderSelect.js